import {
    PosMicrosIntegrationAccountingCategoryListItem,
    PosMicrosIntegrationMicros4700Outlet,
    PosMicrosIntegrationTransmissionProtocol,
    PosMicrosIntegrationXmlPosOutlet,
} from '@mews-commander/data-access';
import { createZodFormResolver, getDefaults } from '@mews/framework';
import {
    accountingCategoryListItemSchema,
    microsOutletFormSchema,
    MicrosOutletFormSchema,
    xmlPosOutletFormSchema,
    XmlPosOutletFormSchema,
} from './formProps';

import { AccountingCategoriesCount } from './accountingCategoriesCount';
import { getMicrosOutletValue, getXmlMicrosOutletValue } from './MicrosOutletHelper';

export const useMicrosOutletFormData = (
    protocol: PosMicrosIntegrationTransmissionProtocol,
    posIntegrationsServiceKeyEnabled: boolean,
    microsOutlet?: PosMicrosIntegrationMicros4700Outlet | PosMicrosIntegrationXmlPosOutlet
) => {
    const resolver =
        protocol === PosMicrosIntegrationTransmissionProtocol.XmlPos && posIntegrationsServiceKeyEnabled
            ? createZodFormResolver<XmlPosOutletFormSchema>(xmlPosOutletFormSchema)
            : createZodFormResolver<MicrosOutletFormSchema>(microsOutletFormSchema);
    const microsOutletSchemaDefaultValues: PosMicrosIntegrationMicros4700Outlet = getDefaults(microsOutletFormSchema);
    const xmlPosOutletSchemaDefaultValues: PosMicrosIntegrationXmlPosOutlet = getDefaults(xmlPosOutletFormSchema);
    const formDefaultValue =
        protocol === PosMicrosIntegrationTransmissionProtocol.XmlPos && posIntegrationsServiceKeyEnabled
            ? xmlPosOutletSchemaDefaultValues
            : microsOutletSchemaDefaultValues;

    const accountingCategoryDefaultValues: PosMicrosIntegrationAccountingCategoryListItem = getDefaults(
        accountingCategoryListItemSchema
    );

    if (protocol === PosMicrosIntegrationTransmissionProtocol.AllianceHosp) {
        microsOutletSchemaDefaultValues.netSalesAccountingCategories = new Array(
            AccountingCategoriesCount.AllianceHospNetSales
        ).fill(accountingCategoryDefaultValues);
    } else {
        microsOutletSchemaDefaultValues.netSalesAccountingCategories = new Array(
            AccountingCategoriesCount.MicrosIpNetSales
        ).fill(accountingCategoryDefaultValues);
    }

    const microsOutletValue =
        protocol === PosMicrosIntegrationTransmissionProtocol.XmlPos && posIntegrationsServiceKeyEnabled
            ? getXmlMicrosOutletValue(xmlPosOutletSchemaDefaultValues, microsOutlet)
            : getMicrosOutletValue(microsOutletSchemaDefaultValues, microsOutlet);

    return {
        resolver,
        formDefaultValue,
        microsOutletValue,
    };
};
